import { format, startOfMonth, startOfWeek } from "date-fns";
import { ro } from "date-fns/locale";

export const DAY_START = 6;
export const DAY_END = 22;
export const HOUR_PX = 56;
export const SNAP = 15;
export const TOTAL_PX = (DAY_END - DAY_START) * HOUR_PX;

export const WEEKDAYS = ["Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"];
export const WEEKDAYS_SHORT = ["L", "Ma", "Mi", "J", "V", "S", "D"];

export const APPT_STATUSES = [
  { value: "programat", label: "Programat" },
  { value: "finalizat", label: "Finalizat" },
  { value: "anulat", label: "Anulat" },
];

export const PALETTE = ["#00B3C7", "#2563EB", "#16A34A", "#F59E0B", "#DC2626", "#9333EA", "#0891B2",
  "#DB2777", "#65A30D", "#EA580C", "#4F46E5", "#0D9488", "#B45309"];

const pad = (n) => String(n).padStart(2, "0");
export const dateKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const hm = (min) => `${pad(Math.floor(min / 60))}:${pad(min % 60)}`;
export const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
export const timeOf = (s) => s.slice(11, 16);
export const weekdayIdx = (d) => (d.getDay() + 6) % 7;
export const mondayOf = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const fmtRo = (d, f) => format(d, f, { locale: ro });
export const topOf = (min) => ((min - DAY_START * 60) / 60) * HOUR_PX;
export const fmtDT = (s) => `${s.slice(8, 10)}.${s.slice(5, 7)}.${s.slice(0, 4)} ${s.slice(11, 16)}`;

export const dayStatus = (staff, d) => {
  const key = dateKey(d);
  const off = staff.time_off?.find((t) => t.start_date <= key && key <= t.end_date);
  if (off) return { off: true, label: off.reason || "Concediu" };
  const wh = staff.working_hours?.[weekdayIdx(d)];
  if (!wh?.enabled) return { off: true, label: "Liber" };
  return { off: false, start: toMin(wh.start), end: toMin(wh.end), label: `${wh.start}–${wh.end}` };
};

export const slotFromClick = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  const min = DAY_START * 60 + ((e.clientY - r.top) / HOUR_PX) * 60;
  const snapped = Math.floor(min / SNAP) * SNAP;
  return hm(Math.min(Math.max(snapped, DAY_START * 60), DAY_END * 60 - SNAP));
};

export const DRAG_TYPE = "application/x-appt";
export const monthGridStart = (d) => mondayOf(startOfMonth(d));
export const nowLocal = () => { const n = new Date(); return `${dateKey(n)}T${hm(n.getHours() * 60 + n.getMinutes())}`; };

export const minutesAt = (e, offsetMin = 0) => {
  const r = e.currentTarget.getBoundingClientRect();
  const min = DAY_START * 60 + ((e.clientY - r.top) / HOUR_PX) * 60 - offsetMin;
  return Math.min(Math.max(Math.round(min / SNAP) * SNAP, DAY_START * 60), DAY_END * 60 - SNAP);
};

export function layoutLanes(events) {
  const sorted = [...events].sort((a, b) => a.start.localeCompare(b.start));
  const result = [];
  let group = [];
  let groupEnd = "";
  const flush = () => {
    const lanes = [];
    const placed = group.map((ev) => {
      let i = lanes.findIndex((end) => end <= ev.start);
      if (i < 0) { i = lanes.length; lanes.push(ev.end); } else lanes[i] = ev.end;
      return { ev, lane: i };
    });
    placed.forEach((p) => result.push({ ...p, lanes: lanes.length }));
    group = [];
  };
  sorted.forEach((ev) => {
    if (group.length && ev.start >= groupEnd) flush();
    if (!group.length) groupEnd = ev.end;
    group.push(ev);
    if (ev.end > groupEnd) groupEnd = ev.end;
  });
  if (group.length) flush();
  return result;
}

export const hoursSummary = (wh = []) => {
  const on = wh.map((d, i) => ({ ...d, i })).filter((d) => d.enabled);
  if (!on.length) return "Fără program";
  const same = on.every((d) => d.start === on[0].start && d.end === on[0].end);
  const days = on.map((d) => WEEKDAYS_SHORT[d.i]).join(" ");
  return same ? `${days} · ${on[0].start}–${on[0].end}` : `${days} · program variabil`;
};
